module.exports = __webpack_public_path__ + "static/media/tree-pruning.d7be8d6a.jpg";